@if (category && category.machinesCount && category.machinesCount > 0) {
  <div class="card mb-3">
    <div class="card-header">
      <div class="row justify-content-between align-items-center">
        <div class="col d-flex align-items-center">
          <div class="category-icon me-2">
            <img [src]="category.categoryIcon" alt=""/>
          </div>
          <strong [innerText]="category.categoryDisplayName"></strong>
          <span [innerText]="'(' + (category.machinesCount || 0) + ')'" class="ml-1"></span>
          @if (isLoading()) {
            <span class="fa-solid fa-spinner fa-spin ml-2"></span>
          }
        </div>
        <div class="col-auto d-flex align-items-center gap-2">
          <div class="dropdown">
            <button type="button"
              class="btn btn-outline-primary btn-xs"
              (click)="toggleColumnPicker($event)"
              [attr.aria-expanded]="isColumnPickerOpen()"
              translate>
              <span class="fa-solid fa-table-columns"></span>
              <span class="ms-1" translate>Columns</span>
            </button>
            @if (isColumnPickerOpen()) {
              <div class="dropdown-menu show p-2 column-picker-menu">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" checked disabled/>
                  <label class="form-check-label" translate>Machine name</label>
                </div>
                @for (col of categoryColumns(); track col.name) {
                  @if (col.name !== 'machineId') {
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox"
                        [checked]="isColumnVisible(col.name)"
                        (change)="toggleColumnVisibility(col.name, $event)"/>
                      <label class="form-check-label" [innerText]="col.label | translate"></label>
                    </div>
                  }
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="p-3">
        <div class="machine-list-search-row mb-3">
          <div class="input-group input-group-sm" [attr.aria-busy]="isSearchLoading()">
            <span class="input-group-text">
              <span class="fa-solid fa-search" aria-hidden="true"></span>
            </span>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="searchInputValue"
              [placeholder]="'Search by name, location, tag, type, metadata…' | translate"
              [attr.aria-label]="'Search machines' | translate"/>
            @if (isSearchLoading()) {
              <span class="input-group-text search-loading-indicator" role="status">
                <span class="fa-solid fa-spinner fa-spin" aria-hidden="true"></span>
                <span class="visually-hidden" translate>Searching</span>
              </span>
            }
          </div>
        </div>

        <div class="table-responsive">
          <table class="table table-hover table-machines-fixed mb-0">
            <thead>
              <tr>
                <th (sort)="onColumnSort($event)"
                  [sortable]="'machineName'"
                  class="sortable" scope="col">
                  <span [innerText]="'Machine name'|translate"
                  [title]="'Machine name'|translate" class="truncate"></span>
                </th>
                @for (headerColumn of visibleCategoryColumns; track headerColumn.name) {
                  @if (isTrafficLightColumn(headerColumn)) {
                    <th class="traffic-light-filter-header" scope="col">
                      <button (click)="toggleTrafficLightFilter($event)"
                        [attr.aria-expanded]="isTrafficLightFilterOpen()"
                        [class.text-primary]="selectedTrafficLightFilter() !== null"
                        [title]="'Filter traffic light status' | translate"
                        aria-haspopup="menu"
                        class="traffic-light-filter-toggle"
                        type="button">
                        <span [innerText]="headerColumn.label | translate" class="truncate"></span>
                        <span aria-hidden="true" class="fa-solid fa-filter"></span>
                      </button>
                      @if (isTrafficLightFilterOpen()) {
                        <div (click)="$event.stopPropagation()"
                          aria-label="Traffic light status filter"
                          class="dropdown-menu show traffic-light-filter-menu"
                          role="menu">
                          @for (option of trafficLightFilterOptions; track option.status) {
                            <button (click)="selectTrafficLightFilter(option.status, $event)"
                              [class.active]="isTrafficLightFilterSelected(option.status)"
                              class="dropdown-item"
                              role="menuitem"
                              type="button">
                              <span [innerText]="option.label | translate"></span>
                            </button>
                          }
                          <div class="dropdown-divider"></div>
                          <button (click)="clearTrafficLightFilter($event)"
                            [disabled]="selectedTrafficLightFilter() === null"
                            class="dropdown-item"
                            role="menuitem"
                            type="button">
                            <span translate>Clear filter</span>
                          </button>
                        </div>
                      }
                    </th>
                  } @else if (isColumnSortable(headerColumn)) {
                    <th (sort)="onColumnSort($event)"
                      [sortable]="headerColumn.name"
                      class="sortable" scope="col">
                      <span [innerText]="headerColumn.label | translate"
                        [title]="headerColumn.label | translate" class="truncate"></span>
                    </th>
                  } @else {
                    <th scope="col">
                      <span [innerText]="headerColumn.label | translate"
                        [title]="headerColumn.label | translate" class="truncate"></span>
                    </th>
                  }
                }
              </tr>
            </thead>
            <tbody>
              @for (machine of shownMachines() | paginate : paginateControlSettings; track machine.id) {
                <tr (click)="onRowClick(machine)"
                  (inViewportAction)="onMachineLineInViewChange($event, machine.id)"
                  [class.machine-row-expanded-parent]="expandedMachineId === machine.id"
                  [inViewportOptions]="{ partial: true, threshold: [0,1] }"
                  class="row-min-height row-text-loading machine-row-expandable"
                  inViewport>
                  <!--MACHINE NAME COLUMN-->
                  <td class="align-middle">
                    <div class="d-flex align-items-start">
                      <button
                        type="button"
                        class="btn btn-link machine-row-toggle p-0 me-2"
                        (click)="onRowToggle(machine, $event)"
                        [attr.aria-controls]="getExpandedRowId(machine.id)"
                        [attr.aria-expanded]="expandedMachineId === machine.id"
                        [attr.aria-label]="((expandedMachineId === machine.id ? 'Collapse details for' : 'Expand details for') | translate) + ': ' + machine.name"
                        [attr.title]="'Expand or collapse details' | translate">
                        <span class="fa-solid"
                          [class.fa-chevron-down]="expandedMachineId === machine.id"
                          [class.fa-chevron-right]="expandedMachineId !== machine.id"
                          aria-hidden="true"></span>
                      </button>
                      <div class="min-width-0">
                        <strong class="truncate d-block">
                      <span [innerHTML]="machine.type" [title]="machine.type"></span>
                    </strong>
                        <span class="text-muted d-block truncate">
                          <span translate>Name</span>:
                          <span [innerHTML]="machine.name" [title]="machine.name"></span>
                        </span>
                      </div>
                    </div>
                  </td>
                  <!-- REST OF COLUMNS-->
                  @for (col of visibleCategoryColumns; track col.name) {
                    <td class="align-middle">
                      <span [ngClass]="displayDetails.get(machine.id)?.get(col.name)?.style || ''">
                        <span [innerHTML]="displayDetails.get(machine.id)?.get(col.name)?.value"></span>
                      </span>
                    </td>
                  }
                </tr>
                @if (expandedMachineId === machine.id) {
                  <tr class="machine-row-expanded">
                    <td [attr.colspan]="visibleCategoryColumns.length + 1" class="bg-light">
                      <div class="machine-expanded-region"
                        [id]="getExpandedRowId(machine.id)"
                        [attr.aria-busy]="isExpandedLoading"
                        [attr.aria-label]="('Details for' | translate) + ': ' + machine.name"
                        role="region">
                        @if (isExpandedLoading) {
                          <span class="fa-solid fa-spinner fa-spin me-2"></span>
                          <span translate>Loading details…</span>
                        } @else {
                          <div class="expanded-details">
                          <div class="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-2">
                            <strong [innerText]="machine.name"></strong>
                            <div class="d-flex flex-wrap gap-2">
                              <button type="button"
                                class="btn btn-outline-primary btn-xs"
                                (click)="onListItemClick(machine.id, $event, true)">
                                <span class="fa-solid fa-arrow-up-right-from-square me-1"></span>
                                <span translate>Machine data visualization</span>
                              </button>
                              <button type="button"
                                class="btn btn-outline-primary btn-xs"
                                (click)="onMachineConfigurationClick(machine, $event)">
                                <span class="fa-solid fa-gear me-1"></span>
                                <span translate>Data configuration</span>
                              </button>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <dl class="mb-0">
                                @if (getMachineDisplayName(machine)) {
                                  <dt translate>Display name</dt>
                                  <dd [innerText]="getMachineDisplayName(machine)"></dd>
                                }
                                @if (getMachineLocation(machine)) {
                                  <dt translate>Location</dt>
                                  <dd [innerText]="getMachineLocation(machine)"></dd>
                                }
                                @if (getMachineAddress(machine)) {
                                  <dt translate>Address</dt>
                                  <dd [innerText]="getMachineAddress(machine)"></dd>
                                }
                                @if (getMachineTag(machine)) {
                                  <dt translate>Tag</dt>
                                  <dd [innerText]="getMachineTag(machine)"></dd>
                                }
                                @if (getMachineOrganization(machine)) {
                                  <dt translate>Organization</dt>
                                  <dd [innerText]="getMachineOrganization(machine)"></dd>
                                }
                                @if (getMachineDatasetLocation(machine)) {
                                  <dt translate>Google dataset location</dt>
                                  <dd [innerText]="getMachineDatasetLocation(machine)"></dd>
                                }
                              </dl>
                            </div>
                          </div>
                        </div>
                        }
                      </div>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
          @if (hasNoResults) {
            <div class="d-flex align-items-center justify-content-center mb-0 mt-3 alert alert-info text-center">
              <em class="fa-solid fa-circle-info mr-2"></em>
              <span translate>No machines found for searched term and filters.</span>
            </div>
          }
        </div>
      </div>
      @if (isPaginationAvailable) {
        <div class="machine-list-pagination-container px-3 mb-3">
          <scitis-ngx-pagination [id]="paginateControlSettings.id"
            [mainClass]="'machine-list-pagination-layout'"
            [itemsPerPageClass]="'machine-list-pagination-rows'"
            [itemsPerPage]="paginateControlSettings.itemsPerPage"
            [itemsPerPageOptions]="itemsPerPageOptions"
            (pageNumberChange)="handlePageChange($event)"
            (itemsPerPageChange)="onItemsPerPageChange($event)">
          </scitis-ngx-pagination>
        </div>
      }
    </div>
  </div>
}
